const nl = {
    validation: {
        empty: 'Moet nog invullen: config/lang/nl.ts'
    }
};

export default nl;
